var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ marquee_holder: true, hidden: !_vm.isShow }},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"marquee text_marquee",attrs:{"id":"textMarquee"}},[_c('div',{staticClass:"marquee-inner"},[_c('div',{staticClass:"marquee-content"},[_c('div',[_vm._v(" "+_vm._s(_vm.marqueeTxt)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }